import { SpaceForPoint } from '~/prix/types/presets/space'
import checkIfTimeIsRealtime from './checkIfTimeIsRealtime'
import { TimeForIncidence } from '~/prix/types/presets/time'
import { AnalysisSetting, Assertions } from '~/packages/variable/variables.typing'
import { Expression } from '~/prix/types/expression'
import { ShapeBase } from '~/prix'

interface Input {
  variable?: any
  space?: SpaceForPoint | null
  time?: TimeForIncidence | null
  analysis?: AnalysisSetting | null
  customValue?: Expression<keyof ShapeBase> | null
  filter?: Expression<keyof ShapeBase> | null
  highlight?: Expression<keyof ShapeBase> | null
  assertions?: Assertions | null
  select?: string[] | null
}

export default function getRecommendedCacheOptions(input: Input) {
  if (
    input.space?.delimitationType === 'custom' ||
    ['customDateRange', 'customDateRangePredicted'].includes(input.time?.type || '') ||
    checkIfTimeIsRealtime(input.time) === true
  ) {
    return {}
  }
  if (input.filter || input.highlight) {
    return {
      back: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 2, // 2 days
        expirationMsForUpdate: 1000 * 60 * 10, // 10 minutes
      },
      front: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 2, // 2 days
        expirationMsForUpdate: 1000 * 60 * 10, // 10 minutes
      },
    }
  }
  if (!input.time) {
    return {
      back: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 2, // 2 days
        expirationMsForUpdate: 1000 * 60 * 15, // 15 minutes
      },
      front: {
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 2, // 2 days
        expirationMsForUpdate: 1000 * 60 * 15, // 15 minutes
      },
    }
  }

  return {
    back: {
      expirationMsForFallback: 1000 * 60 * 60 * 24 * 2, // 2 days
      expirationMsForUpdate: 1000 * 60 * 30, // 30 minutes
    },
    front: {
      expirationMsForFallback: 1000 * 60 * 60 * 24 * 2, // 2 days
      expirationMsForUpdate: 1000 * 60 * 30, // 30 minutes
    },
  }
}
